import { Component, OnInit, OnDestroy,ViewChild,ViewEncapsulation,TemplateRef } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { LoadService } from '../../services/load.service';
import { TagsService } from '../../services/tags.service';
import { UsersService } from '../../services/users.service';
import { ProductsService } from '../../services/products.service';
import { FilterUrlService } from '../../services/filter-url.service';
import { PackingEcService } from '../../services/packingec.service';
import { LotesService } from '../../services/lotes.service';
import { Tags } from '../../model/Tags';
import { PackingEC } from '../../model/PackingEC';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { NgOption } from '@ng-select/ng-select';
import { Observable }  from 'rxjs/Observable';
import { Subscription } from 'rxjs';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/throttleTime';
import 'rxjs/add/observable/fromEvent';

@Component({
  selector: 'packingec',
  templateUrl: './packing-ec.component.html',
  styleUrls: ['./packing-ec.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class PackingEcComponent implements OnInit,OnDestroy {
  public modalRef: BsModalRef;
  public modalRef2: BsModalRef;
  public load:number;
  public primeracarga:boolean;
  public isopen:boolean;
  public alert:string;
  public data_list:any;
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public signupForm2:FormGroup;
  public item_to_update:number;
  public etiquetas:any[];
  public packings:any[];
  public prefix:number;
  public numerocajas:number;
  public kiloscajas:number;
  public numerosaldos:number;
  public kilossaldos:number;
  public cajastotales:number;
  public kilostotales:number;
  public tipopacking:any[];
  public encargadospacking:any[];
  public lineaspacking:any;
  public isview:boolean;
  public tipopackings:string;
  public estadopackings:string;
  public fechapackings:string;
  public lineapackings:string;
  public encargadapackings:string;
  public lotes: NgOption[];
  public productos: NgOption[];
  public lista : any[];
  public lista2 : any[];
  public formCtrlSub: Subscription;
  public formCtrlSub2: Subscription;
  public buscadorlotes : FormControl;
  public buscadorproductos : FormControl;
  public working : boolean;
  public settings = {
    columns:{
      id:{
        header:"Numero de Packing",
        type:"number",
        tipo:"id",
        path:"id",
        filter: { visible:true }
      },
      packing_type_id:{
        header:"Tipo",
        type:"obj",
        tipo:"packing_type_id",
        path:"relationships.type.data.attributes.name",
        filter: { visible:true,  id_type:'number',default:'asc', type:'dd' },
      },
      created_at:{
        header:"Fecha de Creación",
        type:"date",
        tipo:"fecha",
        path:"attributes.date",
        filter: { visible:true }
      },
      packing_status_id:{
        header:"Estado",
        type:"obj",
        tipo:"packing_status",
        path:"relationships.status.data.attributes.name",
        filter: { visible:true,  id_type:'number',default:'asc', type:'dd' }
      },
      amount_box:{header:"Cantidad Cajas",type:"text",ignored:true},
      residue:{header:"Cantidad Saldos",type:"text",ignored:true},
      total_boxes:{header:"Cantidad Total",type:"text",ignored:true},
      kg:{header:"Peso Cajas",type:"text",ignored:true},
      residue_kg:{header:"Peso Saldo",type:"text",ignored:true},
      total:{header:"Kilos Totales",type:"text",ignored:true}
    },
    actions:{
      edit: false,
      view: true,
      delete: false
    }
  };

  public orderProduccionActual:string;

  constructor(private _productsService:ProductsService,
    private _packingecService:PackingEcService,
    private _localeService: BsLocaleService,
    private _tagsService:TagsService,
    private _usersService:UsersService,
    private _loaddata: LoadService,
    private _filter: FilterUrlService,
    private _modalService: BsModalService,
    private _lotesService:LotesService) {
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
    this.etiquetas = [];
    this.prefix = 0;
    this.packings = [];
    this.numerocajas = 0;
    this.kiloscajas = 0;
    this.numerosaldos = 0;
    this.kilossaldos = 0;
    this.cajastotales = 0;
    this.kilostotales = 0;
    this.tipopacking = [];
    this.encargadospacking = [];
    this.lineaspacking = [];
    this.isview = false;
    this.tipopackings = '';
    this.estadopackings = '';
    this.fechapackings = '';
    this.lineapackings = '';
    this.encargadapackings = '';
    this.lotes = [];
    this.lista = [];
    this.lista2 = [];
    this.working = false;
    this.orderProduccionActual = '';
  }

  ngOnInit() {
    this._loaddata.loadChange(15);
    this._localeService.use('es');
    this._filter.filterFirstLoad(this.settings);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);

    this.signupForm = new FormGroup({
      'tipo': new FormControl(null,Validators.required),
      'etiqueta': new FormControl(null),
      'encargado': new FormControl(null,Validators.required),
      'linea': new FormControl(1)
    });

    this.signupForm2 = new FormGroup({
      'lote': new FormControl(null),
      'fecha1': new FormControl(null,Validators.required),
      'fecha2': new FormControl(null,Validators.required),
      'producto': new FormControl(null),
    });

    this.buscadorlotes = new FormControl();
    this.buscadorproductos = new FormControl();
    this.formCtrlSub = this.buscadorlotes.valueChanges.debounceTime(100).subscribe(x => this.onSearchLotes(x));
    this.formCtrlSub2 = this.buscadorproductos.valueChanges.debounceTime(100).subscribe(x => this.onSearchProductos(x));

    this.loadTypePacking();
  }

  ngOnDestroy() {
   this.formCtrlSub.unsubscribe();
   this.formCtrlSub2.unsubscribe();
 }

  loadDataFiltered(filters){
    this.alert = 'Cargando petición de busqueda.';
    this.isopen = true;
    this._loaddata.loadChange(90);
    this._packingecService.getDataFiltered(filters)
    .subscribe(
      (response:any) => {
        this.cleanForm();
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga correcta."
        this.isopen =true;
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        if(error.status == 0){
          this.alert = 'Busqueda sin resultados.';
        }
        else{
          this.showError(error.error.error);
        }
      }
    );
  }

  loadTypePacking():void{
    this.alert = "Cargando información del Packing."
    this.isopen = true;
    this._loaddata.loadChange(30);

    this._packingecService.getTypes().subscribe((response:any) => {
      this.tipopacking = response.data;
      let data = response.data;
      let tipos:string = "{";
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          tipos+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
        }
      }
      tipos = tipos.slice(0,-1);
      tipos+="}";
      this.settings.columns.packing_type_id.filter['data'] = tipos;

      this.loadLinePacking();
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  loadLinePacking():void{
    this._loaddata.loadChange(45);
    this.lineaspacking.push({id:1,name:'Linea 1'},{id:2,name:'Linea 2'},{id:3,name:'Linea 3'});
    this.loadStatusPacking();
  }

  loadStatusPacking():void{
    this.alert = "Cargando tipo de estados."
    this.isopen = true;
    this._loaddata.loadChange(45);

    this._packingecService.getAllStatusPackings().subscribe(
      (response:any) => {
        let data = response.data;
        let estados:string = "{";
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            estados+='"'+data[key].id+'":"'+data[key].attributes.name+'",';
          }
        }
        estados = estados.slice(0,-1);
        estados+="}";
        this.settings.columns.packing_status_id.filter['data'] = estados;

        this.loadPeoplePacking();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  loadPeoplePacking():void{
    this.alert = "Cargando responsables de Packing."
    this.isopen = true;
    this._loaddata.loadChange(60);

    this._usersService.getUsersByRol(5).subscribe((response:any) => {
      this.encargadospacking = response.data;
      this.loadData();
    },
    (error) => {
      //console.log(error);
      this.showError(error.error.error);
    });
  }


/**
 * Carga el listado de informacion.
 */
  loadData():void{
    this.working = false;
    this.alert = 'Preparando petición.';
    this.isopen = true;
    this._loaddata.loadChange(80);
    this._packingecService.get()
    .subscribe(
      (response:any) => {
        //console.log(response.data);
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.isopen =true;
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        //console.log(error);
        this.showError(error.error.error);
      }
    );
  }

  saveForm(){
    this.working = true;
    this.alert = "Creando Packing de Entrada.";
    this.isopen = true;
    this.isNew = true;
    this._loaddata.loadChange(20);
    let packing = {
      'num_cajas':this.numerocajas,
      'num_saldo': this.numerosaldos,
      'cajas_totales':this.cajastotales,
      'kilos_por_caja': this.packings[0].pesoporcaja,
      'kilos_total_cajas':this.kiloscajas,
      'kilos_total_saldos':this.kilossaldos,
      'kilos_totales_packing': this.kilostotales,
      'tipo': this.signupForm.get('tipo').value,
      'encargado':this.signupForm.get('encargado').value,
      'linea':this.signupForm.get('linea').value
    }
    //let prov = this._packingecService.transformData(this.numerocajas,this.numerosaldos,this.cajastotales,this.kiloscajas,this.kilossaldos,this.kilostotales,this.signupForm.get('tipo').value,this.signupForm.get('encargado').value,this.signupForm.get('linea').value);
    let prov = this._packingecService.transformDataPacking(packing);

    //console.log("BODY PETICION CREAR PACKING: ", prov);
    this._packingecService.save(prov).subscribe(
      (response:any) =>{
          let prov2 = this._tagsService.transformData3(this.packings,response.id);
          this._tagsService.update(prov2).subscribe(
            (response:any) =>{
              this.alert = "Packing de entrada generado.";
              this._loaddata.loadChange(60);
              this.hideChildModal();
              this.cleanForm();
              this.loadData();
              this.orderProduccionActual = '';
            },
            (error) => {
              this.showError(error.error.error);
            }
          );
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

/**
 * Carga la información de una fila en el formulario.
 * @param  index Indice de la fila que se carga en el formulario.
 */
 showViewForm(index:any,template: TemplateRef<any>):void{
   this.working = true;
   let item = this.data_list[index];
   let posi = 0;
   this.isview = true;
   this.alert = "Preparando petición.";
   this.isopen = true;
   this._loaddata.loadChange(20);
   this.title = item.id;
   this.isNew = false;

   this.numerocajas = item.attributes.amount_box;
   this.numerosaldos =  item.attributes.residue;
   this.kiloscajas = item.attributes.kg;
   this.kilossaldos = item.attributes.residue_kg;
   this.cajastotales = item.attributes.total_boxes;
   this.kilostotales = item.attributes.total;
   this.tipopackings = item.relationships.type.data.attributes.name;
   this.estadopackings = item.relationships.status.data.attributes.name;
   this.fechapackings = item.attributes.created_at.date;
   this.lineapackings = item.attributes.line;

   for(let mon of this.encargadospacking){
     if(mon.id == parseInt(item.attributes.user_id)){
       this.encargadapackings = this.encargadospacking[posi].attributes.name;
       break;
     }
     posi++;
   }

   this.packings = [];
   let pos = 0;

   this._tagsService.getAllbyPackingInProcess(item.id).subscribe(
     (response:any) => {
       if(response.data.length != 0){
         for(let res of response.data){
            this.packings.push({weight:0,product_id:res.attributes.product_id,client:res.attributes.client,elaboration_date:res.attributes.elaboration_date,lot_code:res.attributes.lot_code,po_number:res.attributes.po_number,prefix:res.attributes.prefix,product_code:res.attributes.product_code,status:res.attributes.status,number_box:res.attributes.number_box,residue:res.attributes.residue});
         }

         for(let packing of this.packings){
           this._productsService.getOne(packing.product_id).subscribe(
             (response:any) => {
               this.packings[pos].weight = parseFloat(response.relationships.properties.data[9].attributes.name);
               pos++;

              if(pos == this.packings.length){
                this._loaddata.loadChange(100);
                this.alert = "Carga Correcta."
                this.onOpenCreateModal(template);
                this.working = false;
                this.onClosedAutomatic();
              }
             },
             (error) => {
               //console.log(error);
               this.showError(error.error.error);
               this.working = false;
             }
           );
         }
       }
       else{
         this._loaddata.loadChange(100);
         this.alert = "Carga correcta. El packing no posee etiquetas relacionadas."
         this.onOpenCreateModal(template);
         this.working = false;
         this.onClosedAutomatic();
       }
     },
     (error) => {
       //console.log(error);
       this.showError(error.error.error);
       this.working = false;
     }
   );
 }

/**
 * Muestra el modal para crear o actualizar segun corresponda.
 * @param tipo si es crear o actualizar
 */
  showChildModal(template: TemplateRef<any>): void {
    this.working = true;
    this.isview = false;
    this.alert = "Cargando etiquetas QR.";
    this.isopen = true;
    this._loaddata.loadChange(20);
    this.title = "Crear Packing de Entrada";
    this.isNew = true;
    this.numerocajas = 0;
    this.numerosaldos = 0;
    this.kiloscajas = 0;
    this.kilossaldos = 0;
    this.cajastotales = 0;
    this.kilostotales = 0;
    this.packings = [];
    this.etiquetas = [];
    this.lista = [];
    this.lista2 = [];
    let pos = 0;

    this._tagsService.getAllbyPrefixInProcess(1).subscribe(
      (response:any) => {
        this._loaddata.loadChange(50);
        this.etiquetas = response.data;

        for (let i of this.etiquetas) {

          // this.lista = [...this.lista,{ id: parseInt(i.attributes.prefix), code: '('+i.attributes.number_box+')'+i.attributes.prefix}]
          this.lista = [...this.lista,{ id: parseInt(i.attributes.prefix), code: ' PRE '+i.attributes.prefix+' | OP'+i.attributes.po_number+' | (Cantidad '+i.attributes.number_box+')'}]

        }

        this._tagsService.getAllbyPrefixInProcess(4).subscribe(
          (response:any) => {
            this.etiquetas = response.data;

            for (let i of this.etiquetas) {
              // this.lista = [...this.lista,{ id: i.attributes.prefix, code: '('+i.attributes.number_box+')'+i.attributes.prefix}]
              this.lista = [...this.lista,{ id: i.attributes.prefix, code: ' PRE '+i.attributes.prefix+' | OP'+i.attributes.po_number+' | (Cantidad '+i.attributes.number_box+')'}]
            }

            this.lista2 = [...this.lista];

            this.onOpenCreateModal(template);
            this._loaddata.loadChange(100);
            this.alert = "Carga correcta de etiquetas QR.";
            this.working = false;
            this.onClosedAutomatic();
          },
          (error) => {
            //console.log(error);
            this.showError(error.error.error);
            this.working = false;
          }
        );
      },
      (error) => {
        //console.log(error);
        this.showError(error.error.error);
        this.working = false;
      }
    );
  }

  onOpenCreateModal(template: TemplateRef<any>){
    this.modalRef = this._modalService.show(template);
  }

/**
 * Cierra el modal
 */
  hideChildModal(): void {
    this.modalRef.hide();
    this.modalRef = null;
  }

  onOpenMenuExcel(template: TemplateRef<any>){
    this.cleanForm2();
    this.lotes = [];
    this.modalRef2 = this._modalService.show(template);
  }

  onChangeBuscador(op,e){
    if(op == 'lote'){
      this.buscadorlotes.setValue(e.target.value);
    }
    else if(op == 'producto'){
      this.buscadorproductos.setValue(e.target.value);
    }
  }

  onSearchProductos(x){
    this.alert = 'Buscando Productos.';
    this.isopen = true;
    this._loaddata.loadChange(40);

    this._productsService.getSomeProducts(x).subscribe(
      (response:any) => {
        this.productos = [];
        for(let prod of response.data){
          this.productos = [...this.productos,{ id: parseInt(prod.id), code: prod.attributes.code }];
        }

        this.alert = "Carga correcta de Productos."
        this._loaddata.loadChange(100);
      },
      (error) => {
        this.alert = "Error al realizar busqueda de productos.";
        this._loaddata.loadChange(100);
      }
    );
  }

  onSearchLotes(x){
    this.alert = 'Buscando lotes';
    this.isopen = true;
    this._loaddata.loadChange(40);

    this._lotesService.getSomeLotes(x).subscribe(
      (response:any) => {
        this.lotes = [];
        for(let lote of response.data){
          this.lotes = [...this.lotes,{ id: parseInt(lote.id), code: lote.attributes.code }];
        }

        this.alert = "Carga correcta de Lotes."
        this._loaddata.loadChange(100);
      },
      (error) => {
        this.alert = "Error al realizar busqueda de lotes.";
        this._loaddata.loadChange(100);
      }
    );
  }

  createExcel(){
    this.alert = "Generando Excel.";
    this.isopen = true;
    this._loaddata.loadChange(30);
    window.open(this._productsService.getExcel(this.signupForm2.value), "_blank");
    this.alert = "Excel generado.";
    this.hideChildModal2();
    this._loaddata.loadChange(100);
    this.onClosedAutomatic();
  }

  /**
   * Cierra el modal
   */
    hideChildModal2(): void {
      this.modalRef2.hide();
      this.modalRef2 = null;
    }

  /**
   * Carga las etiquetas al packing.
   */
  onChangeEtiquetas(){
      this.alert = "Agregando grupo de etiquetas QR.";
      this.isopen = true;
      this._loaddata.loadChange(40);
      let pos = 0;

      this._tagsService.getTagsFromPrefix(this.signupForm.get('etiqueta').value).subscribe(
        (response:any) => {
          /*capturando la orden de producción de las etiquetas*/
          let opconsulta = response.data[0].relationships.production_order.data.attributes.number
          if(this.orderProduccionActual === ''){
            this.orderProduccionActual = opconsulta;
          }
          //console.log("RESPUESTA: ", response);
          //console.log("OP ACTUAL: ", this.orderProduccionActual);
          //console.log("OP CONSULTADA: ", opconsulta);
          /*compruebo si el op del grupo de etiquetas a agregar corresponde al mismo que ya se ha seleccionado*/
          if(opconsulta === this.orderProduccionActual){
            this.packings.push({
              prefijo:0,
              pesoporcaja:0,
              numerocajas:0,
              pesocajas:0,
              numerosaldo:0,
              pesosaldo:0,
              pesototal:0,
              numerocajastotales:0,
              op:'',
              lote:'',
              producto:'',
              cliente:'',
              fecha:''
            });

            let id = (this.packings.length - 1);
            for(let tag of response.data){
              if(tag.attributes.residue == 0){
                this.kiloscajas += parseInt(tag.relationships.product.data.relationships.properties.data[9].attributes.name);
                this.numerocajas += 1;
                this.packings[id].pesoporcaja = tag.relationships.product.data.relationships.properties.data[9].attributes.name;
                this.packings[id].numerocajas += 1;
                this.packings[id].pesocajas += parseInt(tag.relationships.product.data.relationships.properties.data[9].attributes.name);
              }//Saldo
              else{
              this.kilossaldos += tag.attributes.residue;
              this.numerosaldos += 1;
              this.packings[id].numerosaldo = 1;
              this.packings[id].pesosaldo = tag.attributes.residue;
              }
            }

            this.cajastotales = this.numerocajas + this.numerosaldos;
            this.kilostotales = this.kiloscajas + this.kilossaldos;
            this.packings[id].pesototal = this.packings[id].pesocajas + this.packings[id].pesosaldo;
            this.packings[id].numerocajastotales = this.packings[id].numerocajas + this.packings[id].numerosaldo;

            if(response.data.length != 0){
              this.packings[id].op = response.data[0].relationships.production_order.data.attributes.number;
              this.packings[id].lote = response.data[0].relationships.lot.data.attributes.code;
              this.packings[id].producto = response.data[0].relationships.product.data.attributes.code;
              this.packings[id].cliente = response.data[0].relationships.production_order.data.attributes.client;
              this.packings[id].fecha = response.data[0].attributes.elaboration_date;
              this.packings[id].prefijo = response.data[0].attributes.prefix;
            }

            for(let eti of this.lista2){
              if(eti.id == this.signupForm.get('etiqueta').value){
                this.lista2.splice(pos,1);
                this.lista = [];
                this.lista = [...this.lista2];
                break;
              }
              else{
                pos += 1;
              }
            }

            this.signupForm.patchValue({
              'etiqueta': new FormControl(null)
            });

            this._loaddata.loadChange(100);
            this.alert = "Se agregaron etiquetas QR al packing."
            this.onClosedAutomatic();
          }
          else{
            this.signupForm.patchValue({
              'etiqueta': new FormControl(null)
            });

            this.alert = "Solo se pueden agregar etiquetas con la misma Orden de Producción";
            this.isopen = true;
            this._loaddata.loadChange(100);
            this.onClosedAutomatic();
            //console.log("Las atiquetas deben pertenecer a la misma orden de producción");
          }

        },
        (error) => {
          //console.log(error);
          this.showError(error.error.error);
        }
      );
  }

  printForm(){
    this.alert = "Generando archivo PDF.";
    this.isopen = true;
    this._loaddata.loadChange(30);
    window.open(this._packingecService.getPDF(this.title), "_blank");
    this.alert = "PDF generado.";
    this.isopen = true;
    this._loaddata.loadChange(100);
    this.onClosedAutomatic();
  }

/**
 * Elimina un packing, recalcula los valores de numero de cajas
 * y kilos.
 * @param  id posicion dentro del arreglo
 */
  onDeletePacking(id:number):void{
    this.alert = "Realizando operación..";
    this.isopen = true;
    this._loaddata.loadChange(40);
    let pos = 0;

    //console.log(this.packings);

    this.numerocajas -= this.packings[id].numerocajas;
    this.numerosaldos -= this.packings[id].numerosaldo;
    this.kiloscajas -= this.packings[id].pesocajas;
    this.kilossaldos -= this.packings[id].pesosaldo;
    this.cajastotales -= this.packings[id].numerocajastotales;
    this.kilostotales -= this.packings[id].pesototal;
   //code: ' PRE '+i.attributes.prefix+' | OP'+i.attributes.po_number+' | (Cantidad '+i.attributes.number_box+')'
    // this.lista = [...this.lista,{ id: parseInt(this.packings[id].prefijo), code: '('+this.packings[id].numerocajastotales+')'+this.packings[id].prefijo}];
    //console.log("PACKING: ", this.packings[id]);
    this.lista = [...this.lista,{ id: parseInt(this.packings[id].prefijo), code: ' PRE '+this.packings[id].prefijo+' | OP'+this.packings[id].op+' | (Cantidad '+this.packings[id].numerocajastotales+')'}];
    this.lista2 = [...this.lista];
    this.packings.splice(id,1);
    if(this.packings.length == 0){
      this.orderProduccionActual = '';
    }
    this._loaddata.loadChange(100);
    this.alert = "Se quitaron etiquetas QR del packing.";
    this.onClosedAutomatic();
  }

/**
 * Limpia el formulario para volver a utilizarlo despues.
 */
  cleanForm():void{
    this.signupForm.reset();
    this.signupForm = new FormGroup({
      'tipo': new FormControl(null,Validators.required),
      'etiqueta': new FormControl(null),
      'encargado': new FormControl(null,Validators.required),
      'linea': new FormControl(1)
    });
  }

  /**
   * Limpia el formulario para volver a utilizarlo despues.
   */
    cleanForm2():void{
      this.signupForm2.reset();
      this.signupForm2 = new FormGroup({
        'lote': new FormControl(null),
        'fecha1': new FormControl(null,Validators.required),
        'fecha2': new FormControl(null,Validators.required),
        'producto': new FormControl(null),
      });
    }

/**
 * Cierra el mensaje de alerta.
 */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }

/**
 * Muestra un error
 * @param  msg mensaje del error
 */
 showError(msg:string){
   if(msg == undefined){
     this.alert = 'No tiene permisos para realizar la acción.';
   }
   else{
     this.alert = msg;
   }
   this._loaddata.loadChange(100);
   this.isopen =true;
 }

/**
 * Actualiza el listado por la paginacion
 * @param data nuevo listado o mensaje de error.
 */
  updateData(data:any):void{
    if(data === "Error al cargar listado."){
      this.showError(data);
    }
    else{
      this.data_list = data;
    }
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/packing-ec/packing-ec.component.ts